import { useAudio } from '@utils/providers/audio-context.tsx';
import { motion } from 'framer-motion';
import { PrimaryColor } from '@utils/constants/style.ts';

const TranscriptMediaSlider = () => {
  const { setTime, currentTime, duration } = useAudio();

  return (
    <div className={'flex items-center h-full'}>
      <motion.input
        type="range"
        value={currentTime}
        className="w-full h-2 bg-gray-400 dark:bg-zinc-600 rounded-2xl appearance-none cursor-pointer"
        onChange={e => setTime(parseFloat(e.target.value))}
        aria-labelledby="continuous-slider"
        max={duration}
        min={0}
        transition={{ duration: 0.1, ease: 'linear' }}
        style={{
          background: `linear-gradient(to right, ${PrimaryColor} ${(currentTime / duration) * 100}%, #ccc ${
            (currentTime / duration) * 100
          }%)`,
          transition: 'background 0.1s linear'
        }}
      />
    </div>
  );
};

export default TranscriptMediaSlider;
